// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Суспільні виклики» (Public challenges, ключ `pubch`, група `analysis`). */
export const publicChallengesManifest: IModuleManifest = {
  key: 'pubch',
  group: 'analysis',
  slug: 'public-challenges',
  prefix: 'PCH',
  name: { en: 'Public challenges', uk: 'Суспільні виклики' },
  entities: [
    { key: 'pubch', slug: 'pubch', name: { en: 'Challenges', uk: 'Виклики' }, main: true },
    { key: 'psig', slug: 'psig', name: { en: 'Signals', uk: 'Сигнали' }, main: false },
    { key: 'pconf', slug: 'pconf', name: { en: 'Conflicts', uk: 'Конфлікти' }, main: false },
    { key: 'psol', slug: 'psol', name: { en: 'Possible solutions', uk: 'Можливі рішення' }, main: false },
  ],
  loadState: () => import('./state/publicChallengesSlice').then((m) => m.publicChallengesSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
  loadViews: () => import('./views').then((m) => m.views),
};
